import { renderFrame } from '../utils/render-frame';
import { useTimelineContext } from '../utils/use-context';

export const ProjectDurationDisplay: React.FC<{
  fps: number;
}> = ({ fps }) => {
  const { durationInFrames } = useTimelineContext();

  return (
    <div
      title="Project duration"
      className="text-comp-moderate-small text-sys-cont-neutral-light"
    >
      {renderFrame(durationInFrames, fps)}
    </div>
  );
};
